import { NotFoundState } from '@kanos/web-core';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { z } from 'zod';
import { EarlierEngagementPage } from '../firm/engagement-earlier-page';
import { FeatureGate } from '../firm/feature-gate';

export const Route = createFileRoute('/clients/$caseId/mandates/$mandate/engagement')({
  component: EarlierEngagement,
});

/** The number of a client's mandate in the address, counted from 1. */
const mandateNumber = z.coerce.number().int().positive();

/** The contract of one of the client's earlier mandates (ADR-078 § 5), read only. */
function EarlierEngagement() {
  const { caseId, mandate } = Route.useParams();
  const navigate = useNavigate();
  const number = mandateNumber.safeParse(mandate);
  if (!number.success) return <NotFoundState onHome={() => void navigate({ to: '/clients' })} />;
  return (
    <FeatureGate feature="check-point">
      <EarlierEngagementPage caseId={caseId} mandate={number.data} />
    </FeatureGate>
  );
}
